import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Loader from '../Loader';
import ChunkStyled from './styles/ChunkStyled';

class Chunk extends PureComponent {
  constructor(props) {
    super(props);
    this.mounted = false;
    this.state = {
      LoadedComponent: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.mounted = true;
    this.load(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.load !== this.props.load) {
      this.load(nextProps);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  load = (props) => {
    this.setState({
      LoadedComponent: null,
    });

    props.load().then((mod) => {
      if (this.mounted) {
        this.setState({
          // handle both es imports and cjs
          LoadedComponent: mod.default ? mod.default : mod,
        });
      }
    });
  };

  render() {
    const { LoadedComponent } = this.state;
    const { offLoader, bgColor } = this.props;

    return LoadedComponent ? (
      <LoadedComponent {...this.props} />
    ) : (
      !offLoader && (
        <ChunkStyled bgColor={bgColor}>
          <Loader />
        </ChunkStyled>
      )
    );
  }
}

Chunk.propTypes = {
  load: PropTypes.func.isRequired,
  offLoader: PropTypes.bool,
  bgColor: PropTypes.oneOf(['black', 'white']),
};

Chunk.defaultProps = {
  offLoader: false,
  bgColor: 'white',
};

export default Chunk;
